import React from "react";
import { ResponsiveImage, Link } from "@quintype/components";
import PropTypes from "prop-types";
import "./styles.m.css";
import { connect } from "react-redux";

import get from "lodash/get";

function StoryHeaderBase({ story = {}, showHeroImage, iconLiveBlogClass, subTitleClass, publisherAttributes }) {
  const storyTemplateType = get(story, ["metadata", "story-attributes", "layout"], "");
  const subheadline = story.subheadline ? story.subheadline.replace(/&nbsp;/g, "") : "";
  // Get the Hero image
  const getHeroImage = () => {
    return (
      <figure>
        <ResponsiveImage
          slug={story["hero-image-s3-key"]}
          metadata={story["hero-image-metadata"]}
          aspectRatio={[16, 9]}
          defaultWidth={480}
          widths={[250, 480, 640]}
          sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"
          imgParams={{ auto: ["format", "compress"] }}
          alt={story["hero-image-caption"] || story.headline}
        />
        {story["hero-image-caption"] && (
          <figcaption className="story-element-image-title">
            {story["hero-image-caption"].replace(/&nbsp;|&amp;/g, "")}
          </figcaption>
        )}
      </figure>
    );
  };
  return (
    <React.Fragment>
      <div styleName="story-content">
        <div styleName={publisherAttributes.lang === "ur" ? "section-name-urdu" : "section-name"}>
          {<Link href={`/section/${story.sections[0].slug}`}>{get(story, "sections[0].[display-name]")}</Link>}
        </div>
      </div>
      {storyTemplateType[0] === "image-first" ? getHeroImage() : null}
      <h1
        className={`${iconLiveBlogClass} ${publisherAttributes.lang === "hi" ? "hi-title" : null}`}
        styleName={`story-heading ${publisherAttributes.lang === "hi" ? "hi-title" : ""}`}
      >
        {story.headline}
      </h1>
      <h2
        className={`${subTitleClass}`}
        styleName={publisherAttributes.lang === "ur" ? "urdu-story-sub-title" : "story-sub-title"}
      >
        {subheadline}
      </h2>

      {storyTemplateType[0] !== "image-first" && showHeroImage && getHeroImage()}
    </React.Fragment>
  );
}

StoryHeaderBase.propTypes = {
  story: PropTypes.object,
  showHeroImage: PropTypes.bool,
  iconLiveBlogClass: PropTypes.string,
  subTitleClass: PropTypes.string,
  publisherAttributes: PropTypes.object
};

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const StoryHeader = connect(
  mapStateToProps,
  null
)(StoryHeaderBase);
